import React from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { isEmpty } from 'lodash'
import { getFormattedDate } from '../../utils'
import {
    Button,
    DeviceSerialQrCodeModal,
    Modal
} from '../root/components/common'
import classNames from 'classnames'
import { useSwapReplacements } from './hooks/use-swap-replacements'
import { SwapReplacementsTable } from './swap-replacements-table'
import { REPLACEMENT_STATUSES, REPLACEMENT_STATUSES_DE } from './constants'
import { Autocomplete } from '@material-ui/lab'
import { Checkbox, IconButton, TextField } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import Clear from '@material-ui/icons/Clear'
import Input from '../root/components/common/input'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
const checkboxIcon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedCheckboxIcon = <CheckBoxIcon fontSize="small" />

function SwapReplacementsMain() {
    const classes = useStyles()
    const {
        swapReplacements,
        swapReplacementsEvents,
        currentDeviceSerial,
        setCurrentDeviceSerial,
        isOpenQrModal,
        setIsOpenQrModal,
        currentSwapReplacementId,
        setCurrentSwapReplacementId,
        currentSwapReplacement,
        replacementsLocations,
        currentReplacementsLocation,
        setCurrentReplacementsLocation,
        refresh,
        search,
        setSearch,
        isCancelReplacementModalOpen,
        setIsCancelReplacementModalOpen,
        onConfirmReplacementCancel,
        numberToConfirmCancel,
        userNumberToConfirmCancel,
        setUserNumberToConfirmCancel,
        isConfirmCancelError,
        statusPickerOptions,
        filterStatuses,
        setFilterStatuses,
        removeReplacementDevice
    } = useSwapReplacements()

    const onQrIconClick = deviceSerial => {
        setCurrentDeviceSerial(deviceSerial)
        setIsOpenQrModal(true)
    }

    const onRowClick = id => {
        setCurrentSwapReplacementId(id)
    }

    return (
        <React.Fragment>
            <div className={classNames(classes.wrapper)}>
                <div style={{ flex: 1, height: '100%' }}>
                    <div
                        style={{
                            marginBottom: 18,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton
                                size="medium"
                                onClick={refresh}
                                style={{ marginRight: 12 }}>
                                <RefreshIcon />
                            </IconButton>
                            <Autocomplete
                                options={replacementsLocations}
                                style={{ width: 300 }}
                                getOptionLabel={option => option.name}
                                renderInput={params => {
                                    return (
                                        <TextField
                                            {...params}
                                            label="Standort der Ersatzgeräte"
                                            variant="outlined"
                                            InputProps={{
                                                ...{
                                                    style: { borderRadius: 7 }
                                                },
                                                ...params.InputProps
                                            }}
                                        />
                                    )
                                }}
                                value={currentReplacementsLocation}
                                onChange={(event, newValue) => {
                                    setCurrentReplacementsLocation(newValue)
                                }}
                                noOptionsText="Nicht gefunden"
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                            <div style={{ marginRight: 12 }}>
                                <Autocomplete
                                    multiple
                                    options={statusPickerOptions}
                                    style={{ width: 400 }}
                                    limitTags={1}
                                    getOptionLabel={option => option.name}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            InputProps={{
                                                ...{
                                                    style: { borderRadius: 7 }
                                                },
                                                ...params.InputProps
                                            }}
                                        />
                                    )}
                                    getOptionSelected={(option, value) => {
                                        return option.key === value.key
                                    }}
                                    renderOption={(option, { selected }) => {
                                        return (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={checkboxIcon}
                                                    checkedIcon={
                                                        checkedCheckboxIcon
                                                    }
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )
                                    }}
                                    value={filterStatuses}
                                    onChange={(event, newValue) => {
                                        setFilterStatuses(newValue)
                                    }}
                                    noOptionsText="Status wurde nicht gefunden"
                                />
                            </div>
                            <div style={{ width: 260 }}>
                                <Input
                                    value={search}
                                    label={'Suchen'}
                                    type="text"
                                    setValue={setSearch}
                                    debounce={600}
                                    endIcon={() =>
                                        search ? (
                                            <IconButton
                                                onClick={() => setSearch('')}
                                                classes={{
                                                    root: classes.saerchClearIcon
                                                }}>
                                                <Clear />
                                            </IconButton>
                                        ) : null
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(swapReplacements) ? (
                        <SwapReplacementsTable
                            // sorting={filters.sort_by}
                            // onSort={sort_by => d({ type: 'sort', sort_by })}
                            // isLoadingMore={isLoadingMore}
                            // isLoading={isLoading}
                            // onLoadMore={loadMoreDevices}
                            onRowClick={onRowClick}
                            swapReplacements={swapReplacements}
                            onQrIconClick={onQrIconClick}
                            // showAssignmentColumn
                            removeReplacementDevice={removeReplacementDevice}
                            search={search}
                        />
                    ) : (
                        <div>Nicht gefunden</div>
                    )}
                </div>

                <div
                    style={{
                        width: 300,
                        paddingLeft: 16,
                        overflowY: 'scroll'
                    }}>
                    {!currentSwapReplacementId ? (
                        <div
                            style={{
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                            Bitte Ersatz wählen
                        </div>
                    ) : (
                        <>
                            <h2>
                                Verlauf:{' '}
                                {
                                    currentSwapReplacement?.customer_device_serial_number
                                }
                            </h2>
                            {isEmpty(swapReplacementsEvents) ? (
                                <div>
                                    {`Die Ersetzung ist noch nicht gestartet`}
                                </div>
                            ) : (
                                <div>
                                    {swapReplacementsEvents.map((sre, idx) => {
                                        return (
                                            <EventItem
                                                key={sre.id}
                                                idx={idx}
                                                item={sre}
                                                eventsLength={
                                                    swapReplacementsEvents.length
                                                }
                                                setIsCancelReplacementModalOpen={
                                                    setIsCancelReplacementModalOpen
                                                }
                                            />
                                        )
                                    })}

                                    {currentSwapReplacementId &&
                                    isCancelReplacementModalOpen ? (
                                        <Modal
                                            open={isCancelReplacementModalOpen}
                                            setOpen={
                                                setIsCancelReplacementModalOpen
                                            }>
                                            <div>
                                                <div>
                                                    Bist du 100% sicher, dass
                                                    diese Ersetzung rückgängig
                                                    gemacht werden muss?
                                                </div>
                                                <div>
                                                    Bitte geben Sie diese Nummer
                                                    ein, um die Ersetzung
                                                    rückgängig zu machen:
                                                </div>
                                                {isCancelReplacementModalOpen && (
                                                    <div
                                                        style={{
                                                            textAlign: 'center',
                                                            fontSize: 40,
                                                            fontWeight: 'bold'
                                                        }}>
                                                        {numberToConfirmCancel}
                                                    </div>
                                                )}
                                                <Input
                                                    label="Sicherheitscode"
                                                    isError={
                                                        isConfirmCancelError
                                                    }
                                                    type="text"
                                                    setValue={
                                                        setUserNumberToConfirmCancel
                                                    }
                                                    value={
                                                        userNumberToConfirmCancel
                                                    }
                                                    onEnter={onConfirmReplacementCancel.bind(
                                                        this,
                                                        currentSwapReplacementId
                                                    )}
                                                />
                                                <div
                                                    className={
                                                        classes.modalButtons
                                                    }>
                                                    <Button
                                                        onClick={onConfirmReplacementCancel.bind(
                                                            this,
                                                            currentSwapReplacementId
                                                        )}>
                                                        {'Ok'}
                                                    </Button>
                                                    <Button
                                                        reverted
                                                        onClick={setIsCancelReplacementModalOpen.bind(
                                                            this,
                                                            false
                                                        )}>
                                                        {'Abbrechen'}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Modal>
                                    ) : null}
                                </div>
                            )}
                        </>
                    )}
                </div>

                <DeviceSerialQrCodeModal
                    deviceSerial={currentDeviceSerial}
                    open={isOpenQrModal}
                    setOpen={setIsOpenQrModal}
                />
            </div>
        </React.Fragment>
    )
}

function EventItem({
    item,
    idx,
    key,
    eventsLength,
    setIsCancelReplacementModalOpen
}) {
    return (
        <div key={key}>
            <div style={{ display: 'flex' }}>
                <div>
                    {idx + 1}
                    {'. '}
                </div>
                <div style={{ flex: 1, paddingLeft: 8 }}>
                    <div>
                        {REPLACEMENT_STATUSES_DE[item.event_type]}
                        {(item.event_type ===
                            REPLACEMENT_STATUSES.replacement_scanned ||
                            item.event_type ===
                                REPLACEMENT_STATUSES.replacement_scanned_again) &&
                        item.data?.replacement_device_id &&
                        item.data?.replacement_device_serial_number ? (
                            <>
                                {`: `}
                                <div>
                                    <NavLink
                                        to={`/devices/${item.data.replacement_device_id}`}
                                        target={'_blank'}
                                        style={{
                                            color: 'black',
                                            textDecoration: 'none',
                                            fontWeight: 'bold',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                opacity: 0.3
                                            }
                                        }}>
                                        (
                                        {
                                            item.data
                                                .replacement_device_serial_number
                                        }
                                        )
                                    </NavLink>
                                </div>
                            </>
                        ) : null}
                    </div>
                    <div>{getFormattedDate(item.created_at)}</div>
                    <div>{item.user_name}</div>
                </div>
            </div>
            {idx + 1 !== eventsLength ? (
                <>
                    <div
                        style={{
                            height: 18,
                            borderBottom: '1px dotted #9c9c9c'
                        }}></div>
                    <div style={{ height: 18 }}></div>
                </>
            ) : null}
            {item.event_type === REPLACEMENT_STATUSES.replaced &&
            idx + 1 === eventsLength ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: 30
                    }}>
                    <Button
                        onClick={setIsCancelReplacementModalOpen.bind(
                            this,
                            true
                        )}
                        error>
                        Ersetzung rückgängig machen
                    </Button>
                </div>
            ) : null}
            {/* {item.event_type === REPLACEMENT_STATUSES.before_shipment_scanned &&
            idx + 1 === eventsLength ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: 30
                    }}>
                    <Button onClick={() => {}} cta>
                        Als versandt markieren
                    </Button>
                </div>
            ) : null} */}
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    switcher: {
        marginRight: 12
    },
    wrapper: {
        height: 'calc(100% - 70px)',
        display: 'flex'
    },
    actions: {
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        color: theme.primary,
        cursor: 'pointer'
    },

    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    modalButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 15
    },
    pickerWrapper: {
        marginTop: 15
    },
    pageTitle: {
        justifyContent: 'space-between'
    },
    searchInput: {
        width: '35%'
    },

    input: {
        fontSize: 14,
        height: '32px',
        width: 150,
        borderRadius: '4px'
    },
    title: {
        marginBottom: 0
    },
    filterSelect: {
        marginRight: 16
    },
    statusFilterItem: {
        fontSize: 14
    },
    placeholderFilter: {
        color: theme.palette.text.secondary
    },
    filtersWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    saerchClearIcon: {
        padding: 0,
        position: 'absolute',
        right: 14
    },
    exportBtnsWrapper: {
        display: 'flex',
        gap: '6px',
        marginRight: '16px'
    },
    loader: {
        top: '50vh',
        zIndex: 9,
        position: 'absolute',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    disabledWrapper: {
        opacity: 0.3,
        pointerEvents: 'none'
    }
}))
export default withRouter(SwapReplacementsMain)
